import React from 'react';

class SDGSALWDescription extends React.PureComponent {
  render() {
    return (
      <div className={ this.props.className }>
        <p>
         The illicit trade in small arms and light weapons has implications for the achievement of several Goals of the 2030 Agenda for Sustainable Development, including those relating to peace, justice and strong institutions, poverty reduction, economic growth, health, gender equality, and safe cities and communities. States have agreed therefore to take advantage of PoA national reporting to support data collection for relevant indicators, in particular SDG indicator 16.4.2 under Target 16.4 on significant reduction of illicit arms flows. Such data collected through national reports are aggregated, analyzed and reported to the Department of Social and Economic Affairs (DESA), as a solid contribution of the PoA process to the SDG framework.{' '}
        </p>
      </div>
    );
  }
}

export default SDGSALWDescription;



// WEBPACK FOOTER //
// ./src/components/SustainableDevGoals/SDGSALWDescription.js